import { ICompanyTitle } from './models/models'

/**
 * Seçili şirketin tam ticari unvanı (Faz-42). Unvan sunucudan gelir
 * (`payment/getCompanyTitles` → `IndexCompanyNames`); ön yüzde SABİTLENMEZ, çünkü hukuki
 * metindir ve tek kaynakta kalmalıdır.
 *
 * Şirket seçili değilken, kod tanınmadığında veya unvan boş geldiğinde `null` döner — ekrana
 * boş başlık basılmaması için çağıran bu değeri kontrol eder.
 */
export const companyTitleFor = (
  companyCode: number | undefined,
  titles: ICompanyTitle[]
): string | null => {
  if (!companyCode) return null

  const match = titles.find(item => item.Code === companyCode)
  const title = match?.Title?.trim()

  return title ? title : null
}
